import { createFileRoute } from '@tanstack/react-router';
import FinancialManagement from '../../components/manager/FinancialManagement';
import ManagerPortal from '../../components/portals/ManagerPortal';

export const Route = createFileRoute('/manager/financial')({
  component: FinancialManagementRoute,
});

function FinancialManagementRoute() {
  return (
    <ManagerPortal>
      <FinancialManagement />
    </ManagerPortal>
  );
}
